import { DocumentLibraryService } from './document-library.service';

export default angular
  .module('sfMobile.services.document-library', ['simplifield.feature-flags'])
  .service('documentLibraryService', DocumentLibraryService).name;
